module.exports = () =>
  typeof document !== 'undefined' && 'classList' in document.createElement('a');
